// Guardia de una pantalla por permisos RBAC: sin todos los permisos no se monta la pantalla, así
// que tampoco dispara sus llamadas al API. El back vuelve a validar cada endpoint.
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/hooks/useAuth';
import { ErrorState } from '@/kit';

export interface RequirePermissionsProps {
    /** Permisos que la pantalla exige; se piden todos. */
    permissions: readonly string[];
    children: ReactNode;
}

export function RequirePermissions({ permissions, children }: RequirePermissionsProps) {
    const { t } = useTranslation('common');
    const { permissions: granted } = useAuth();
    const allowed = permissions.every((key) => granted.has(key));
    if (!allowed) return <ErrorState title={t('screenNoAccess')} />;
    return <>{children}</>;
}
